import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=bf3d1e12&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports